import { Input } from '@/components/ui/Input'
import { SenseGlossLine } from '@/components/vocabulary/SenseGlossLine'

interface TypingQuestionProps {
  questionText: string
  senseGloss?: string
  value: string
  onChange: (value: string) => void
  onSubmit?: () => void
  placeholder?: string
}

export function TypingQuestion({
  questionText,
  senseGloss,
  value,
  onChange,
  onSubmit,
  placeholder = 'Type your answer',
}: TypingQuestionProps) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold leading-snug text-foreground sm:text-2xl">{questionText}</h2>
        <SenseGlossLine gloss={senseGloss} />
      </div>
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onEnter={onSubmit}
        placeholder={placeholder}
        autoFocus
        className="h-12 text-base"
      />
    </div>
  )
}
